<div class="card mt-4">
  <h4 class="card-header">Request Access</h4>
  <div class="card-body">
    <div class="container">
      <form [formGroup]="requestAccessForm" (ngSubmit)="submitForm()">

        <input type="hidden" name="communityid" formControlName="propertyid">
        <div class="form-group input-group-lg">
          <input class="form-control" placeholder="Username" formControlName="username" >
        </div>
        <div class="form-group input-group-lg">
          <input class="form-control" placeholder="Property Name" id="propertyname" formControlName="propertyname" >
        </div>
        <div class="form-group input-group-lg">
          <input class="form-control" placeholder="Property Address" id="propertyaddress" formControlName="propertyaddress" >
        </div>
        @if (home) {
          <div class="form-group input-group-lg">
            <input class="form-control" placeholder="Index" id="index" formControlName="index" [pattern]="indexPattern"  [ngClass]="{ 'is-invalid': submitted && f.index.errors }">
            @if (submitted && f.index.errors) {
              <div class="invalid-feedback">
                @if (f.index.errors.required) {
                  <div>Property index is required</div>
                }
              </div>
            }
            @if (f.index && f.index.errors?.pattern) {
              <div class="invalid-feedback">
                Property Index has to be a number .e.g 5
              </div>
            }
          </div>
        }
        @if (home) {
          <div class="form-group input-group-lg">
            <input class="form-control" placeholder="Access Key" id="accesskey" formControlName="accesskey" [pattern]="accessPattern"  [ngClass]="{ 'is-invalid': submitted && f.accesskey.errors }">
            @if (submitted && f.accesskey.errors) {
              <div class="invalid-feedback">
                @if (f.accesskey.errors.required) {
                  <div>Property access key is required</div>
                }
              </div>
            }
            @if (f.accesskey && f.accesskey.errors?.pattern) {
              <div class="invalid-feedback">
                Property access key has to be 7 or more characters in length
              </div>
            }
          </div>
        }

        <!-- <div class="form-group input-group-md">


        <label class="font-weight-bold" for="usertype">User Type <fa-icon  [icon]="faQuestionCircle"></fa-icon></label>

        <select class="form-control" id="usertype" formControlName="usertype"  [ngClass]="{ 'is-invalid': submitted && f.usertype.errors }">
          <option *ngFor="let userType of userTypes" [ngValue]="userType.id">
            {{userType.labeltxt}}
          </option>
        </select>
        <div *ngIf="submitted && f.usertype.errors" class="invalid-feedback">
          <div *ngIf="f.usertype.errors.required">User Type is required</div>
        </div>
      </div> -->

      <div class="form-group">
        <button class="mt-2 btn btn-info btn-block btn-lg">Request Access <fa-icon class="l-icon" [icon]="faPaperPlane"></fa-icon></button>
      </div>
    </form>
  </div>
</div>
</div>